import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import 'kea-thunk'
import { kea } from 'kea'
import update from 'react/lib/update';

import PicFSUpload from '../../Common/picFSUpload';
import { httpGet, httpPost, httpPut } from '../../Util/http';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import { dateToStringWithMonth2 as dateToStringWithMonth } from '../../Util/dateTime'


import { connect } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';

import { greyScaleColors, semanticColors } from '../../Globals/styles';
import auth from '../../Login/authService'

const incrementerLogic = kea({
    actions: () => ({
        fetching: (status) => ({
            status
        }),
        saving: (status) => ({
            status
        }),
        setImage: (base64) => ({
            base64
        }),
        increase: true,
        setMessages: (messages) => ({
            messages
        }),
        sendMessage: (message, username, image) => ({
            message,
            fullName: username,
            id: Math.random(),
            date: new Date(),
            time: 'Nu',
            image
        })
    }),
    reducers: ({ actions }) => ({
        counter: [0, PropTypes.number, {
            [actions.increase]: (state, payload) => state + 1
        }],
        messages: [[], PropTypes.array, {
            [actions.sendMessage]: (state, payload) => {
                return update(state, {
                    $unshift: [payload]
                })
            },
            [actions.setMessages]: (state, payload) => {
                return update(state, {
                    $set: payload.messages
                })
            }
        }],
        uploadImage: ["", PropTypes.string, {
            [actions.setImage]: (state, payload) => {
                return update(state, {
                    $set: payload.base64
                })
            }
        }],
        fetching: [false, PropTypes.bool, {
            [actions.fetching]: (state, payload) => {
                return update(state, {
                    $set: payload.status
                })
            }
        }],
        saving: [false, PropTypes.bool, {
            [actions.saving]: (state, payload) => {
                return update(state, {
                    $set: payload.status
                })
            }
        }]
    }),
    thunks: ({ actions, get, fetch, dispatch, getState }) => ({
        increaseAsync: async (ms) => {
            await actions.increase()
        },
        submitAsync: async (message, username, chatId, image) => {
            var url = process.env.REACT_APP_webApiEndPoint + "api/arbejdsmiljo/chat/" + chatId
            await actions.saving(true)
            let img = await httpPost(url, {
                message,
                fullName: username,
                image
            })
                .then(resp => resp.json())
                .then((json) => json.url)
                .catch((e) => {
                    dispatch(addAlert('Kunne ikke gemme besked'))
                })
            await actions.setImage('')
            await actions.sendMessage(message, username, img)
            await actions.saving(false)
        },
        getAsync: async (id) => {
            var url = process.env.REACT_APP_webApiEndPoint + "api/arbejdsmiljo/chat/" + id
            await actions.fetching(true)
            await httpGet(url)
                .then(resp => resp.json())
                .then((json) => {
                    actions.setMessages(json.messages.reverse())
                })
                .catch((e) => {
                    dispatch(addAlert('Kunne ikke hente beskeder'))
                })
            await actions.fetching(false)
        }
    })
})

class Chat extends Component {
    componentWillMount() {
        this.props.actions.getAsync(this.props.activityId)
    }
    submit = () => {
        if (this.refs.textArea.value.replace(/^\s+|\s+$/g, "").length < 1) return;
        this.props.actions.submitAsync(this.refs.textArea.value, auth.getProfile().name, this.props.activityId, this.props.uploadImage)
        this.refs.textArea.value = "";
    };
    renderSpinner = (loading) => {
        return loading ? (<div style={styles.spinner}><i className="fa fa-spinner fa-spin fa-2x"></i></div>) : null;
    };
    render() {
        const chatMessages = this.props.messages
        const user = auth.getProfile();
        var date;
        var messages = chatMessages.map((chatMessage) => {
            let isOwn = chatMessage.fullName === user.name ? true : false;
            var shouldDisplayDate = false;
            let parsed = dateToStringWithMonth(new Date(chatMessage.date))
            if (date !== parsed) {
                shouldDisplayDate = true;
                date = parsed
            }
            return (
                <div key={chatMessage.id}>
                    {shouldDisplayDate ?
                        <div style={styles.dateDelimiter}>
                            <div style={styles.dateDelimiterLine}></div>
                            <div style={styles.date}>{date}</div>
                        </div>
                        : null
                    }
                    <div style={styles.chatMessage}>
                        <div style={[styles.header, isOwn && styles.headerOwn]}>{chatMessage.fullName}</div>
                        <div style={[styles.message, isOwn && styles.messageOwn]}>{chatMessage.message}</div>
                        <div style={[styles.time, isOwn && styles.timeOwn]}>{chatMessage.time}</div>
                    </div>
                    {chatMessage.image ?
                        <img
                            onClick={() => {
                                var node = {
                                    document: {
                                        fileUrl: chatMessage.image
                                    }
                                }
                                this.props.show(node)
                            }}
                            style={{ maxWidth: '-webkit-fill-available', display: 'block', margin: 'auto', cursor: 'pointer' }}
                            src={chatMessage.image}
                        />
                        : null}
                </div>
            )
        })
        return (
            <div>
                <textArea ref="textArea" style={styles.textArea} placeholder="Skriv besked ..." />
                <div style={{ width: '100%', paddingBottom: 5 }}>
                    {this.props.saving ?
                        this.renderSpinner(this.props.saving)
                        :
                        <div>
                            <button
                                style={{ width: '85%', borderTopRightRadius: 0, borderBottomRightRadius: 0, textIndent: 55 }}
                                className="btn btn-primary waves-btn"
                                onClick={this.submit}>
                                {"Gem"}
                            </button>
                            {this.props.uploadImage ?
                                <div style={{ display: 'inline-block', width: '15%', paddingTop: '1px' }}>
                                    <button
                                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, width: '100%' }}
                                        className="btn btn-primary"
                                        onClick={() => {
                                            this.props.actions.setImage('')
                                        }}
                                    >
                                        <span className="fa-stack">
                                            <i
                                                aria-hidden="true"
                                                className="fa fa-picture-o fa-stack-1x"
                                            />
                                            <i
                                                style={{ paddingLeft: 25, fontSize: 12 }}
                                                aria-hidden="true"
                                                className="fa fa-times fa-stack-2x"
                                            />
                                        </span>
                                    </button>
                                </div>
                                :
                                <PicFSUpload
                                    style={{ display: 'inline-block', width: '15%' }}
                                    onFilesSelected={files => {
                                        var reader = new FileReader();
                                        reader.onload = (function (f) {
                                            return function (e) {
                                                let base = e.target.result.split(',')[1]
                                                this.props.actions.setImage(base)
                                            };
                                        })(files[0]).bind(this);

                                        // Read in the image file as a data URL.
                                        reader.readAsDataURL(files[0]);
                                    }}
                                    multiple={false}
                                >
                                    <button
                                        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0, width: '100%' }}
                                        className="btn btn-primary waves-btn"
                                    >
                                        <i
                                            aria-hidden="true"
                                            className="fa fa-camera"
                                        />
                                    </button>
                                </PicFSUpload>
                            }
                        </div>
                    }
                </div>

                <div ref="messageContainer">
                    <div ref="messageInnerContainer">
                        {messages}
                        {this.renderSpinner(this.props.fetching)}
                    </div>
                </div>
            </div>
        );
    }
}

var styles = {
    textArea: {
        top: '0',
        width: '100%',
        minHeight: '130px',
        resize: 'none',
        border: 'none',
        padding: '10px'
    },
    chatMessage: {
        width: '100%',
        margin: '12px 0'
    },
    header: {
        fontWeight: '600',
        fontSize: '15px'
    },
    headerOwn: {
        textAlign: 'right'
    },
    message: {
        borderRadius: '4px',
        backgroundColor: '#EBEEF0',
        padding: '10px',
        textAlign: 'justify',
        whiteSpace: 'pre-wrap'
    },
    messageOwn: {
        backgroundColor: semanticColors.primaryLight
    },
    time: {
        fontSize: '12px',
        textAlign: 'right',
        color: greyScaleColors.greyLight
    },
    timeOwn: {
        textAlign: 'right'
    },
    dateDelimiter: {
        height: '20px',
        position: 'relative'
    },
    dateDelimiterLine: {
        borderBottom: '1px solid ' + greyScaleColors.greyLight,
        position: 'absolute',
        top: '10px',
        width: '100%'
    },
    date: {
        backgroundColor: semanticColors.default,
        width: '150px',
        position: 'absolute',
        left: '45%',
        marginLeft: '-60px',
        textAlign: 'center'
    },
    spinner: {
        textAlign: 'center',
        marginBottom: '10px'

    }
}

export default incrementerLogic(Radium(Chat));


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/chat.js